export const orderMonth = (array) => {
	const monthOrder = [
		"Enero",
		"Febrero",
		"Marzo",
		"Abril",
		"Mayo",
		"Junio",
		"Julio",
		"Agosto",
		"Septiembre",
		"Octubre",
		"Noviembre",
		"Diciembre",
	];
	const sorted = array.sort((a, b) => {
		return monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month);
	});
	return sorted;
};

export const orderWeek = (array) => {
	const dayOrder = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sábado"];
	const sorted = array.sort((a, b) => {
		return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
	});
	return sorted;
};
